import ThemedPressable from 'components/atoms/ThemedPressable'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedItem from 'components/atoms/ThemedItem'
import IconView from 'scenes/home/more/index/component/IconView'
import React from 'react'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { colorList } from 'utils/colors'


const HomeMoreButton = ({ icon, text, onPress, testID, destructive = false }) => {
	
	return (
		<ThemedPressable
			onPress={ onPress }
			accessibilityRole="button"
			accessibilityLabel={ text }
			testID={ testID }>
			
			<ThemedBlock shadow>
				<ThemedItem
					accessoryLeft={ <IconView icon={ icon } /> }
					accessoryLeftSize={ 50 }
					titleStyle={ destructive ? styles.destructiveText : null }
					actionItem={
						<Icon
							icon={ IconSystemConstants.ARROW_RIGHT }
							style={ destructive ? styles.destructiveChevron : styles.chevron }
						/>
					}
					title={ text }
				/>
			</ThemedBlock>
		</ThemedPressable>
	);
}

const styles = {
	chevron: {
		fontSize: 14,
		color: colorList.TEXT_HINT.primary,
	},
	destructiveChevron: {
		fontSize: 14,
		color: colorList.RED.dark,
	},
	destructiveText: {
		color: colorList.RED.dark,
	},
};

export default HomeMoreButton
